var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-set" },
    [
      _c(
        "el-form",
        {
          ref: "Entity",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("实体商品")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "实体商品利润率控制：",
                        prop: "entity_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.entity_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "entity_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.entity_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "实体售价范围：" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "entity_price_range_start" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "90px" },
                              attrs: { placeholder: "最低", disabled: "" },
                              model: {
                                value: _vm.marketSet.entity_price_range_start,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "entity_price_range_start",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.entity_price_range_start",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("span", { staticStyle: { margin: "0 3px" } }, [
                          _vm._v(" - "),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "entity_price_range_end" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "90px" },
                              attrs: { placeholder: "最高", disabled: "" },
                              model: {
                                value: _vm.marketSet.entity_price_range_end,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "entity_price_range_end",
                                    $$v
                                  )
                                },
                                expression: "marketSet.entity_price_range_end",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.entity_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "实体商品利润率：",
                            prop: "entity_profit_rate",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "请输入", disabled: "" },
                              model: {
                                value: _vm.marketSet.entity_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "entity_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.entity_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.entity_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "实体商品利润率：",
                            prop: "channel_entity_profit_rate",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { disabled: "", placeholder: "请输入" },
                              model: {
                                value: _vm.marketSet.channel_entity_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_entity_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_entity_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-divider"),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "品牌筛选规则：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.marketSet.entity_brand_sort_rule,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "entity_brand_sort_rule",
                                $$v
                              )
                            },
                            expression: "marketSet.entity_brand_sort_rule",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("渠道规则"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("个性化规则"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "品牌筛选：" } },
                    [
                      _vm.marketSet.entity_brand_sort_rule === "0"
                        ? _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: true },
                              model: {
                                value:
                                  _vm.marketSet.channel_entity_brand_sort_open,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_entity_brand_sort_open",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_entity_brand_sort_open",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("开启"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("关闭"),
                              ]),
                            ],
                            1
                          )
                        : _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.marketSet.entity_brand_sort_open,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "entity_brand_sort_open",
                                    $$v
                                  )
                                },
                                expression: "marketSet.entity_brand_sort_open",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("开启"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("关闭"),
                              ]),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户平台级包邮：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.marketSet.is_show_free_shipping,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "is_show_free_shipping",
                                $$v
                              )
                            },
                            expression: "marketSet.is_show_free_shipping",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("开启包邮"),
                          ]),
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("关闭包邮"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Cake",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("蛋糕到家")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "蛋糕到家利润率控制：",
                        prop: "cake_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.cake_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "cake_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.cake_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.cake_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "cake_profit_rate",
                            label: "蛋糕到家利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "例：25", disabled: "" },
                              model: {
                                value: _vm.marketSet.cake_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "cake_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.cake_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.cake_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_cake_profit_rate",
                            label: "蛋糕到家利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "例：25", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_cake_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_cake_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_cake_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "cakeStore",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("蛋糕到店")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "蛋糕到店利润率控制：",
                        prop: "cake_store_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.cake_store_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "cake_store_profit_rate_control",
                                $$v
                              )
                            },
                            expression:
                              "marketSet.cake_store_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.cake_store_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "cake_store_profit_rate",
                            label: "蛋糕到店利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "例：25", disabled: "" },
                              model: {
                                value: _vm.marketSet.cake_store_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "cake_store_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.cake_store_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.cake_store_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_cake_store_profit_rate",
                            label: "蛋糕到店利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "例：25", disabled: "" },
                              model: {
                                value:
                                  _vm.marketSet.channel_cake_store_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_cake_store_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_cake_store_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "cakeStoreSxd",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("蛋糕自由兑")]),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.cakeStoreSxd_tabName,
                callback: function ($$v) {
                  _vm.cakeStoreSxd_tabName = $$v
                },
                expression: "cakeStoreSxd_tabName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "利润率控制", name: "cakeStoreSxd_rate" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "蛋糕自由兑利润率控制：",
                                prop: "cake_store_sxd_profit_rate_control",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "inputStyle",
                                  attrs: {
                                    placeholder: "请输入",
                                    disabled: "",
                                  },
                                  model: {
                                    value:
                                      _vm.marketSet
                                        .cake_store_sxd_profit_rate_control,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.marketSet,
                                        "cake_store_sxd_profit_rate_control",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "marketSet.cake_store_sxd_profit_rate_control",
                                  },
                                },
                                _vm._l(_vm.controlList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.marketSet.cake_store_sxd_profit_rate_control ==
                          "1"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "cake_store_sxd_profit_rate",
                                    label: "蛋糕自由兑利润率：",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticClass: "inputStyle",
                                      attrs: {
                                        placeholder: "例：25",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.marketSet
                                            .cake_store_sxd_profit_rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.marketSet,
                                            "cake_store_sxd_profit_rate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "marketSet.cake_store_sxd_profit_rate",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.marketSet.cake_store_sxd_profit_rate_control ===
                          "0"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "channel_cake_store_sxd_profit_rate",
                                    label: "蛋糕自由兑利润率：",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticClass: "inputStyle",
                                      attrs: {
                                        placeholder: "例：25",
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          _vm.marketSet
                                            .channel_cake_store_sxd_profit_rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.marketSet,
                                            "channel_cake_store_sxd_profit_rate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "marketSet.channel_cake_store_sxd_profit_rate",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "永辉超市分类限制",
                    name: "cakeStoreSxd_yhcs",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  "【永辉超市线下刷】按商品分类设置黑名单：",
                                "label-width": "280px",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.yonghuiBlackListValue,
                                    callback: function ($$v) {
                                      _vm.yonghuiBlackListValue = $$v
                                    },
                                    expression: "yonghuiBlackListValue",
                                  },
                                },
                                _vm._l(
                                  _vm.yonghuiBlackListOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _c("span", [
                                _vm._v(_vm._s(_vm.yonghuiBlackListInfo)),
                              ]),
                              _c(
                                "el-button",
                                {
                                  staticClass: "blacklist-btn",
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { size: "small", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openBlacklistDrawer()
                                    },
                                  },
                                },
                                [_vm._v("查看规则 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "沃尔玛分类限制",
                    name: "cakeStoreSxd_woerma",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("woermaCouponCustomer", {
                            attrs: {
                              couponConfig: _vm.WoermaCoupon,
                              edit: false,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: { label: "黑/白名单品牌", name: "cakeStoreSxd_hbmd" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "客户级黑/白名单品牌：" } },
                            [
                              [0, 1].includes(_vm.brandAction)
                                ? _c("span", [
                                    _vm._v(
                                      " 【" +
                                        _vm._s(
                                          _vm.brandAction === 1
                                            ? "白名单"
                                            : "黑名单"
                                        ) +
                                        "】已设置" +
                                        _vm._s(_vm.brandTotal) +
                                        "个 "
                                    ),
                                  ])
                                : _c("span", [_vm._v(" 未设置 ")]),
                              _vm._v(" （仅对开放式生效） "),
                              _c("el-input", {
                                attrs: {
                                  rows: 5,
                                  disabled: "",
                                  type: "textarea",
                                  placeholder: "无",
                                },
                                model: {
                                  value: _vm.brandList,
                                  callback: function ($$v) {
                                    _vm.brandList = $$v
                                  },
                                  expression: "brandList",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Code",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("电子码")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "电子码利润率控制：",
                        prop: "code_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.code_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "code_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.code_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.code_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "code_profit_rate",
                            label: "电子码利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.code_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "code_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.code_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.code_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_code_profit_rate",
                            label: "电子码利润率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的正数",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_code_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_code_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_code_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "VipCard",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("权益直充")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "权益直充利润率控制：",
                        prop: "vip_card_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.vip_card_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "vip_card_profit_rate_control",
                                $$v
                              )
                            },
                            expression:
                              "marketSet.vip_card_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.vip_card_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "vip_card_profit_rate",
                            label: "权益直充利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.vip_card_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "vip_card_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.vip_card_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.vip_card_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_vip_card_profit_rate",
                            label: "权益直充利润率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的正数",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value:
                                  _vm.marketSet.channel_vip_card_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_vip_card_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_vip_card_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "OnlineFoods",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("在线点单")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "在线点单利润率控制：",
                        prop: "foods_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.foods_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "foods_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.foods_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.foods_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "foods_profit_rate",
                            label: "在线点单利润率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.foods_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "foods_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.foods_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.foods_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_foods_profit_rate",
                            label: "在线点单利润率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_foods_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_foods_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_foods_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "div",
                {
                  staticClass: "brand__style",
                  on: {
                    click: function ($event) {
                      _vm.showChild = !_vm.showChild
                    },
                  },
                },
                [
                  _vm._v(" 个性化品牌 "),
                  _c("i", {
                    class: _vm.showChild
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right",
                  }),
                ]
              ),
              _vm.showChild
                ? _vm._l(_vm.marketSet.foods_child, function (son, sonindx) {
                    return _c(
                      "el-form",
                      {
                        key: sonindx,
                        ref: "form_" + sonindx,
                        refInFor: true,
                        staticClass: "form",
                        attrs: {
                          model: son,
                          "label-suffix": ":",
                          inline: true,
                        },
                        nativeOn: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                key: son.id,
                                attrs: {
                                  rules: [
                                    {
                                      required: true,
                                      message: "请填写数字格式，仅限两位小数",
                                    },
                                    {
                                      pattern:
                                        /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                      message: "请填写数字格式，仅限两位小数",
                                    },
                                  ],
                                  label: son.brand_name + "利润率",
                                  "label-width": "170px",
                                  prop: "profit_rate",
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    staticClass: "inputStyle",
                                    attrs: {
                                      disabled: !son.edit,
                                      clearable: "",
                                      placeholder: "请输入",
                                    },
                                    model: {
                                      value: son.profit_rate,
                                      callback: function ($$v) {
                                        _vm.$set(son, "profit_rate", $$v)
                                      },
                                      expression: "son.profit_rate",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "MtDaodian",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("美团到店")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "美团到店服务费率控制：",
                        prop: "mt_daodian_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.mt_daodian_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "mt_daodian_profit_rate_control",
                                $$v
                              )
                            },
                            expression:
                              "marketSet.mt_daodian_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.mt_daodian_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "mt_daodian_profit_rate",
                            label: "美团到店服务费率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.mt_daodian_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "mt_daodian_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.mt_daodian_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.mt_daodian_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_mt_daodian_profit_rate",
                            label: "美团到店服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value:
                                  _vm.marketSet.channel_mt_daodian_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_mt_daodian_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_mt_daodian_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "MtWaimai",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("美团外卖")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "美团外卖服务费率控制：",
                        prop: "mt_waimai_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.mt_waimai_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "mt_waimai_profit_rate_control",
                                $$v
                              )
                            },
                            expression:
                              "marketSet.mt_waimai_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.mt_waimai_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "mt_waimai_profit_rate",
                            label: "美团外卖服务费率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.mt_waimai_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "mt_waimai_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.mt_waimai_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.mt_waimai_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_mt_waimai_profit_rate",
                            label: "美团外卖服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value:
                                  _vm.marketSet.channel_mt_waimai_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_mt_waimai_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_mt_waimai_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "dingD",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("叮咚买菜")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "叮咚买菜服务费率控制：",
                        prop: "ding_d_profit_rate_control",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.ding_d_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "ding_d_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.ding_d_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.ding_d_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "ding_d_profit_rate",
                            label: "叮咚买菜服务费率：",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.ding_d_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "ding_d_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.ding_d_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.ding_d_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_ding_d_profit_rate",
                            label: "叮咚买菜服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_ding_d_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_ding_d_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_ding_d_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "yongH",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("h4", [_vm._v("永辉超市")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "永辉超市服务费率控制：",
                        prop: "yong_h_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "永辉超市服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.yong_h_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "yong_h_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.yong_h_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.yong_h_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "yong_h_profit_rate",
                            label: "永辉超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.yong_h_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "yong_h_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.yong_h_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.yong_h_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_yong_h_profit_rate",
                            label: "永辉超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_yong_h_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_yong_h_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_yong_h_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Xxcs",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("h4", [_vm._v("小象超市")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "小象超市服务费率控制：",
                        prop: "xxcs_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "小象超市服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.xxcs_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "xxcs_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.xxcs_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.xxcs_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "xxcs_profit_rate",
                            label: "小象超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.xxcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "xxcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.xxcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.xxcs_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_xxcs_profit_rate",
                            label: "小象超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_xxcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_xxcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_xxcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        { ref: "Drf", attrs: { model: _vm.marketSet, "label-width": "170px" } },
        [
          _c("h4", [_vm._v("大润发")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "大润发服务费率控制：",
                        prop: "drf_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "大润发服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.drf_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "drf_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.drf_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.drf_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "drf_profit_rate",
                            label: "大润发服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.drf_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "drf_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.drf_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.drf_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_xxcs_profit_rate",
                            label: "大润发服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_drf_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_drf_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.channel_drf_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Qmcs",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("h4", [_vm._v("清美超市")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "清美超市服务费率控制：",
                        prop: "qmcs_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "清美超市服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.qmcs_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "qmcs_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.qmcs_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.qmcs_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "qmcs_profit_rate",
                            label: "清美超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.qmcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "qmcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.qmcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.qmcs_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_qmcs_profit_rate",
                            label: "清美超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_qmcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_qmcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_qmcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Tmcs",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("h4", [_vm._v("天猫超市")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "天猫超市服务费率控制：",
                        prop: "tmcs_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "天猫超市服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.tmcs_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "tmcs_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.tmcs_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.tmcs_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "tmcs_profit_rate",
                            label: "天猫超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.tmcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "tmcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.tmcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.tmcs_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_tmcs_profit_rate",
                            label: "天猫超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_tmcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_tmcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_tmcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Hmcs",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("h4", [_vm._v("盒马超市")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "盒马超市服务费率控制：",
                        prop: "hmcs_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "盒马超市服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.hmcs_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "hmcs_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.hmcs_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.hmcs_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "hmcs_profit_rate",
                            label: "盒马超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.hmcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "hmcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.hmcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.hmcs_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_hmcs_profit_rate",
                            label: "盒马超市服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_hmcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_hmcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_hmcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-divider"),
                  _vm.marketSet.hm_goods_detail_customize
                    ? _c("hm-setting", {
                        attrs: { edit: false },
                        model: {
                          value: _vm.marketSet.hm_goods_detail_customize,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.marketSet,
                              "hm_goods_detail_customize",
                              $$v
                            )
                          },
                          expression: "marketSet.hm_goods_detail_customize",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        { ref: "Qcs", attrs: { model: _vm.marketSet, "label-width": "170px" } },
        [
          _c("h4", [_vm._v("屈臣氏")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "屈臣氏服务费率控制：",
                        prop: "qcs_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "屈臣氏服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.qcs_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "qcs_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.qcs_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.qcs_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "qcs_profit_rate",
                            label: "屈臣氏服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.qcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "qcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.qcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.qcs_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_qcs_profit_rate",
                            label: "屈臣氏服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_qcs_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_qcs_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.channel_qcs_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "DrfSmg",
          attrs: { model: _vm.marketSet, "label-width": "185px" },
        },
        [
          _c("h4", [_vm._v("大润发扫码购")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "大润发扫码购服务费率控制：",
                        prop: "drf_smg_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "大润发扫码购服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.drf_smg_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "drf_smg_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.drf_smg_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.drf_smg_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "drf_smg_profit_rate",
                            label: "大润发扫码购服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.drf_smg_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "drf_smg_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.drf_smg_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.drf_smg_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_drf_smg_profit_rate",
                            label: "大润发扫码购服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value:
                                  _vm.marketSet.channel_drf_smg_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_drf_smg_profit_rate",
                                    $$v
                                  )
                                },
                                expression:
                                  "marketSet.channel_drf_smg_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-divider"),
                  _vm.marketSet.drf_smg_goods_detail_customize
                    ? _c("drf-smg-setting", {
                        attrs: { edit: false },
                        model: {
                          value: _vm.marketSet.drf_smg_goods_detail_customize,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.marketSet,
                              "drf_smg_goods_detail_customize",
                              $$v
                            )
                          },
                          expression:
                            "marketSet.drf_smg_goods_detail_customize",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-divider"),
                  _c("drfSmgCompanyCustomer", {
                    ref: "drfSmgCompanyCustomerEl",
                    attrs: {
                      companyConfig: _vm.marketSet.DrfSmgCompany,
                      edit: false,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        { ref: "Mdl", attrs: { model: _vm.marketSet, "label-width": "170px" } },
        [
          _c("h4", [_vm._v("麦德龙商超")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "麦德龙商超服务费率控制：",
                        prop: "mdl_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "麦德龙商超服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.mdl_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "mdl_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.mdl_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.mdl_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "mdl_profit_rate",
                            label: "麦德龙商超服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.mdl_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "mdl_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.mdl_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.mdl_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_mdl_profit_rate",
                            label: "麦德龙商超服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_mdl_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_mdl_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.channel_mdl_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        { ref: "Wph", attrs: { model: _vm.marketSet, "label-width": "170px" } },
        [
          _c("h4", [_vm._v("唯品会")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "唯品会服务费率控制：",
                        prop: "wph_profit_rate_control",
                        rules: [
                          {
                            required: true,
                            message: "唯品会服务费率控制不能为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: { placeholder: "请输入", disabled: "" },
                          model: {
                            value: _vm.marketSet.wph_profit_rate_control,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.marketSet,
                                "wph_profit_rate_control",
                                $$v
                              )
                            },
                            expression: "marketSet.wph_profit_rate_control",
                          },
                        },
                        _vm._l(_vm.controlList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.marketSet.wph_profit_rate_control == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "wph_profit_rate",
                            label: "唯品会服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.wph_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "wph_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.wph_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.marketSet.wph_profit_rate_control === "0"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "channel_wph_profit_rate",
                            label: "唯品会服务费率：",
                            rules: [
                              {
                                pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
                                message: "输入值为保留2位小数的数字",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "inputStyle",
                              attrs: { placeholder: "", disabled: "" },
                              model: {
                                value: _vm.marketSet.channel_wph_profit_rate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "channel_wph_profit_rate",
                                    $$v
                                  )
                                },
                                expression: "marketSet.channel_wph_profit_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "Movie",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("电影")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "电影价格显示区间：",
                        prop: "movie_price_section_start",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: { placeholder: "最低", disabled: "" },
                        model: {
                          value: _vm.marketSet.movie_price_section_start,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.marketSet,
                              "movie_price_section_start",
                              $$v
                            )
                          },
                          expression: "marketSet.movie_price_section_start",
                        },
                      }),
                      _vm._v(" - "),
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: { placeholder: "最高", disabled: "" },
                        model: {
                          value: _vm.marketSet.movie_price_section_end,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.marketSet,
                              "movie_price_section_end",
                              $$v
                            )
                          },
                          expression: "marketSet.movie_price_section_end",
                        },
                      }),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v(
                          " 配置后，则仅显示配置金额内的电影，0表示不限制。 "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否展示电影邻近场次：",
                        prop: "show_near_schedule",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "near",
                          staticStyle: { display: "flex" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.marketSet.show_near_schedule,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "show_near_schedule",
                                    $$v
                                  )
                                },
                                expression: "marketSet.show_near_schedule",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "image" },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("示例图"),
                              ]),
                              _c("el-image", {
                                staticStyle: {
                                  width: "24px",
                                  height: "40px",
                                  "margin-left": "10px",
                                },
                                attrs: {
                                  src: require("@/assets/near.jpg"),
                                  "preview-src-list": [
                                    require("@/assets/near.jpg"),
                                  ],
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v(" 配置后，影院列表中近期场次将不会展示 "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              (_vm.marketSet.movie_price_section_start !== "0" &&
                _vm.marketSet.movie_price_section_start) ||
              (_vm.marketSet.movie_price_section_end !== "0" &&
                _vm.marketSet.movie_price_section_end)
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "电影价格限制类型：",
                            prop: "movie_price_limit_type",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.marketSet.movie_price_limit_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.marketSet,
                                    "movie_price_limit_type",
                                    $$v
                                  )
                                },
                                expression: "marketSet.movie_price_limit_type",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: "0" } },
                                [
                                  _vm._v(" 按排期价格限制 "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "top-start",
                                        content:
                                          "展示影院排期时，仅展示在价格配置区间内排期；选座时座位价格不受限制",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "el-icon-warning-outline img-icon",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-radio",
                                { attrs: { label: "1" } },
                                [
                                  _vm._v(" 按座位价格限制 "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "top-start",
                                        content:
                                          "展示影院排期时，仅展示在价格配置区间内排期；选座时高于上限的座位将无法下单。",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "el-icon-warning-outline img-icon",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "设置影院黑名单：", prop: "cinema" } },
                    [
                      _vm.movieList.cinema
                        ? _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: { placeholder: "", disabled: "" },
                            model: {
                              value: _vm.movieList.cinema,
                              callback: function ($$v) {
                                _vm.$set(_vm.movieList, "cinema", $$v)
                              },
                              expression: "movieList.cinema",
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "inputStyle",
                              staticStyle: { color: "red" },
                            },
                            [_vm._v("暂未设置")]
                          ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.setCinemaBlackList },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "设置影片黑名单：", prop: "movie" } },
                    [
                      _vm.movieList.movie
                        ? _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: { placeholder: "", disabled: "" },
                            model: {
                              value: _vm.movieList.movie,
                              callback: function ($$v) {
                                _vm.$set(_vm.movieList, "movie", $$v)
                              },
                              expression: "movieList.movie",
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "inputStyle",
                              staticStyle: { color: "red" },
                            },
                            [_vm._v("暂未设置")]
                          ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.setFilmBlackList },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "设置不出票手机号：" } },
                    [
                      _vm.blackMobilesCount === 0
                        ? _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v("未设置"),
                          ])
                        : _c("span", { staticStyle: { color: "#409EFF" } }, [
                            _vm._v(
                              "已设置" + _vm._s(_vm.blackMobilesCount) + "个"
                            ),
                          ]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.setNotTicketPhoneBlacklist },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "interview" }),
      _c(
        "el-form",
        {
          ref: "Dudu",
          attrs: { model: _vm.marketSet, "label-width": "170px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("演出")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "订单支付环节，会对设置黑名单商品分类演出进行拦截",
                                placement: "top-start",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline",
                              }),
                            ]
                          ),
                          _vm._v(" 演出商品分类黑名单 "),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "inputStyle",
                          attrs: {
                            value: _vm.yanchuClassifyType,
                            disabled: "",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 0, label: "默认规则" },
                          }),
                          _c("el-option", {
                            attrs: { value: 1, label: "个性化规则" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.yanchuBlacklistLabel } },
                    [_c("span", [_vm._v(_vm._s(_vm.yanchuBlacklistNames))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "interview" }),
        ],
        1
      ),
      _c("filmBlacklist", { ref: "filmBlack", attrs: { module: _vm.module } }),
      _c("cinemaBlacklist", {
        ref: "cinemaBlack",
        attrs: { module: _vm.module },
      }),
      _c("cakeStoreBlacklistDrawer", {
        ref: "cakeStoreBlacklistDrawer",
        attrs: { mode: _vm.yonghuiBlackListValue },
      }),
      _c("notTicketPhoneBlacklist", {
        ref: "notTicketPhoneBlack",
        attrs: {
          readonly: true,
          module: _vm.module,
          customer_id: _vm.id,
          customer_account_id: _vm.accountId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }